import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Form, Button, Alert } from 'react-bootstrap';
import { FiHome } from 'react-icons/fi';
import { useAuth } from '../context/AuthContext';
import toast from 'react-hot-toast';

export const RegisterPage: React.FC = () => {
  const [id, setId] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [inviteCode, setInviteCode] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');
  const { register } = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setIsLoading(true);

    const result = await register(id, password, name, inviteCode);

    if (result.success) {
      toast.success('회원가입 성공!');
      navigate('/');
    } else {
      setError(result.message || '회원가입에 실패했습니다.');
    }

    setIsLoading(false);
  };

  return (
    <div className="login-page">
      <div className="login-container">
        <div className="login-header">
          <div className="login-logo">
            <FiHome />
          </div>
          <h1 className="login-title">회원가입</h1>
          <p className="login-subtitle">청소관리 시스템</p>
        </div>

        <div className="login-form">
        {error && (
          <Alert variant="danger" className="mb-3">
            {error}
          </Alert>
        )}

        <Form onSubmit={handleSubmit}>
          <Form.Floating className="mb-3">
            <Form.Control
              type="text"
              id="userId"
              placeholder="아이디"
              value={id}
              onChange={(e) => setId(e.target.value)}
              required
              minLength={4}
              autoComplete="username"
            />
            <label htmlFor="userId">아이디 (4자 이상)</label>
          </Form.Floating>

          <Form.Floating className="mb-3">
            <Form.Control
              type="password"
              id="password"
              placeholder="비밀번호"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              minLength={4}
              autoComplete="new-password"
            />
            <label htmlFor="password">비밀번호 (4자 이상)</label>
          </Form.Floating>

          <Form.Floating className="mb-3">
            <Form.Control
              type="text"
              id="name"
              placeholder="이름"
              value={name}
              onChange={(e) => setName(e.target.value)}
              required
              autoComplete="name"
            />
            <label htmlFor="name">이름</label>
          </Form.Floating>

          <Form.Floating className="mb-4">
            <Form.Control
              type="text"
              id="inviteCode"
              placeholder="초대 코드"
              value={inviteCode}
              onChange={(e) => setInviteCode(e.target.value.toUpperCase())}
              required
              maxLength={6}
            />
            <label htmlFor="inviteCode">초대 코드</label>
          </Form.Floating>

          <Button
            variant="primary"
            type="submit"
            className="w-100"
            disabled={isLoading}
          >
            {isLoading ? '가입 중...' : '회원가입'}
          </Button>
        </Form>

        <div className="text-center mt-3">
          <Link to="/login" className="text-decoration-none">
            로그인으로 돌아가기
          </Link>
        </div>
        </div>
      </div>
    </div>
  );
};
